export const previewTypes = {
  FIRST_20_SEC: 'first-20-sec',
  TRAILER: 'trailer',
  // type 'url' is temporarily commented, will return in vod phase 2
  // URL: 'url',
  NONE: 'none',
};

export default _.values(previewTypes);



// WEBPACK FOOTER //
// ./src/shared/constants/preview-types.js